/**
 * Compiled-in USD-base FX rates (1 USD = rate[CUR]) for when the live rate
 * fetch fails: the /api/geo/currency proxy's catch, `getCurrencyData()`'s
 * catch, and the injected LP currency layer until its geo fetch answers.
 *
 * One home for all three. The Go server keeps its own copy in
 * services/api/internal/pricing/rates.go (`fallbackUSDRates`, same values,
 * same as-of date); `npm run check:fallback-rates` fails when the two disagree
 * or when the snapshot is older than its staleness budget.
 *
 * Why staleness is a money bug: psychological rounding snaps whole prices to a
 * 7/9 last digit, so a few percent of rate drift can move a displayed price by
 * a whole step. At the old AUD 1.52, a $9 add-on rendered A$19 while the server
 * (live rate 1.437) charged A$9.
 *
 * Refresh: https://api.frankfurter.dev/v1/latest?base=USD&symbols=EUR,GBP,CHF,CAD,AUD,ZAR
 * then update the values + FALLBACK_RATES_AS_OF here AND in rates.go.
 *
 * ZAR is a DISPLAY-only rate (South-Africa PPP funnel); it is never a switcher
 * or charge currency.
 */
export const FALLBACK_RATES_AS_OF = "2026-10-16";

export const FALLBACK_USD_RATES: Readonly<Record<string, number>> = Object.freeze({
  USD: 1,
  EUR: 0.88865,
  GBP: 0.74989,
  CHF: 0.82396,
  CAD: 1.4161,
  AUD: 1.437,
  ZAR: 16.4338,
});

/** JS object literal of the fallback rates, for the injected LP script. */
export function fallbackRatesJsLiteral(): string {
  return `{${Object.entries(FALLBACK_USD_RATES)
    .map(([k, v]) => `${k}:${v}`)
    .join(", ")}}`;
}
